var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FdButton',{attrs:{"styling":"emphasized"}},[_vm._v("Emphasized Button")]),_c('FdButton',[_vm._v("Regular Button")]),_c('FdButton',{attrs:{"styling":"light"}},[_vm._v("Light Button")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }